// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GoogleReviewCard__card___1Jhd8{padding:24px}.GoogleReviewCard__header___3o0VL{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px}.GoogleReviewCard__thumbnail___3NwBJ{width:32px;height:32px;margin-right:16px;border-radius:16px}.GoogleReviewCard__profile___1JcpY{display:flex;align-items:center;width:100%}.GoogleReviewCard__icon___1_FcY{width:22px;height:22px}.GoogleReviewCard__info___1L0dX{color:#807c6c}.GoogleReviewCard__info___1L0dX strong{color:inherit;font-weight:400;font-size:16px;line-height:24px;color:#564f34}.GoogleReviewCard__score___2C_7F{display:flex;margin-top:25px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"card": "GoogleReviewCard__card___1Jhd8",
	"header": "GoogleReviewCard__header___3o0VL",
	"thumbnail": "GoogleReviewCard__thumbnail___3NwBJ",
	"profile": "GoogleReviewCard__profile___1JcpY",
	"icon": "GoogleReviewCard__icon___1_FcY",
	"info": "GoogleReviewCard__info___1L0dX",
	"score": "GoogleReviewCard__score___2C_7F"
};
module.exports = ___CSS_LOADER_EXPORT___;
